/* Shared attendance-grid constants & pure date helpers. */

// Fallback statuses used only on first render before the dynamic config loads.
export const FALLBACK_STATUSES = [
  { code: 'present',    short_code: 'P',  name: 'Present',    color: 'bg-emerald-500 text-white' },
  { code: 'absent',     short_code: 'A',  name: 'Absent',     color: 'bg-rose-500 text-white' },
  { code: 'leave',      short_code: 'L',  name: 'Leave',      color: 'bg-amber-500 text-white' },
  { code: 'half_day',   short_code: 'HD', name: 'Half Day',   color: 'bg-orange-500 text-white' },
  { code: 'holiday',    short_code: 'H',  name: 'Holiday',    color: 'bg-violet-500 text-white' },
  { code: 'week_off',   short_code: 'WO', name: 'Week Off',   color: 'bg-slate-400 text-white' },
  { code: 'not_joined', short_code: 'NJ', name: 'Not Joined', color: 'bg-slate-200 text-slate-600' },
];

export const todayIso = () => new Date().toISOString().slice(0, 10);

export const addDays = (iso, n) => {
  const d = new Date(iso);
  d.setDate(d.getDate() + n);
  return d.toISOString().slice(0, 10);
};

export const dowShort = (iso) => {
  const d = new Date(iso + 'T12:00:00Z');
  return ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][d.getUTCDay()];
};

export const dayNum = (iso) => Number(iso.slice(8, 10));

export const fmtTs = (ts) =>
  ts ? new Date(ts).toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' }) : '';

export const cellKey = (traineeId, date) => `${traineeId}|${date}`;
